import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { update, fetch } from '../../../Api/definitionCourseEnterprise';

const useCourse = setIsLoading => {
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch().then(data => {
      setCourses(data.coursesByEnterprises);
      setCategories(data.categories);
      setIsLoading(false);
      const idArr = [];
      data.coursesByEnterprises.forEach((courseArray, index) => {
        // checks 'isChecked' value
        if (courseArray[courseArray.length - 1]) {
          idArr.push(courseArray[4]);
        }
      });
      setDefaultSelectedIds(Array.from(idArr));
    });
  }, []);

  const saveCourses = courseData => {
    update(courseData)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    setCourses,
    categories,
    saveCourses,
    setCategories,
    defaultSelectedIds,
  };
};

export default useCourse;
